// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__256zE","emails":"CreateEditClinics_emails__UHz8k","emailTagLabel":"CreateEditClinics_emailTagLabel__1Z2-L"};